var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":!_vm.hasTooltip,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('osdi-button',_vm._g(_vm._b({attrs:{"color":_vm.$attrs.color || 'secondary',"icon-only":""}},'osdi-button',_vm.$attrs,false),_vm.eventHandlers(_vm.$listeners, on)))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }